
import React from 'react';

interface SkeletonLoaderProps {
  className?: string;
  variant?: 'text' | 'rectangular' | 'circular' | 'card';
  lines?: number;
  height?: string;
  width?: string;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  className = '',
  variant = 'rectangular',
  lines = 1,
  height = 'h-4',
  width = 'w-full'
}) => {
  const baseClasses = 'animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]';
  
  const variantClasses = {
    text: `${height} ${width} rounded`,
    rectangular: `${height} ${width} rounded-lg`,
    circular: `${height} ${width} rounded-full`,
    card: 'h-48 w-full rounded-lg'
  };

  if (variant === 'text' && lines > 1) {
    return (
      <div className={`space-y-2 ${className}`}>
        {Array.from({ length: lines }).map((_, index) => (
          <div
            key={index}
            className={`${baseClasses} ${variantClasses.text} ${
              index === lines - 1 ? 'w-3/4' : 'w-full'
            }`}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`} />
  );
};

// Skeleton específico para cards de serviços
export const ServiceCardSkeleton: React.FC = () => (
  <div className="bg-[#1C1C1C] rounded-xl p-6 border border-[#333] animate-pulse">
    <div className="flex items-center mb-4">
      <SkeletonLoader variant="circular" height="h-12" width="w-12" className="mr-4" />
      <SkeletonLoader variant="text" height="h-6" width="w-32" />
    </div>
    <SkeletonLoader variant="text" lines={3} className="mb-4" />
    <SkeletonLoader variant="rectangular" height="h-10" width="w-full" />
  </div>
);

// Skeleton específico para galeria
export const GallerySkeleton: React.FC = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {Array.from({ length: 6 }).map((_, index) => (
      <SkeletonLoader key={index} variant="card" />
    ))}
  </div>
);

// Skeleton específico para depoimentos
export const TestimonialSkeleton: React.FC = () => (
  <div className="bg-[#1C1C1C] rounded-xl p-6 border border-[#333] animate-pulse">
    <div className="flex items-center mb-4">
      <SkeletonLoader variant="circular" height="h-12" width="w-12" className="mr-4" />
      <div>
        <SkeletonLoader variant="text" height="h-4" width="w-24" className="mb-2" />
        <SkeletonLoader variant="text" height="h-3" width="w-16" />
      </div>
    </div>
    <SkeletonLoader variant="text" lines={3} />
  </div>
);
